/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { eDependencies } from './dependenciesE.generated';
import { createUppercaseE } from '../../factoriesAny.js';
export var EDependencies = {
  eDependencies: eDependencies,
  createUppercaseE: createUppercaseE
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesUppercaseE.generated.js
// module id = 1541
// module chunks = 0